import React, { useEffect, useState } from "react";
import { Trophy, TrendingDown, AlertTriangle } from "lucide-react";
import { api } from "../lib/api";

const fmtGbp = (v) => `£${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export default function MarginLeaderboard() {
  const [data, setData] = useState(null);
  const [months, setMonths] = useState(12);
  useEffect(() => {
    let alive = true;
    api.get(`/opex/margin-leaderboard?months=${months}`).then(({ data }) => { if (alive) setData(data); }).catch(() => {});
    return () => { alive = false; };
  }, [months]);

  if (!data || data.count === 0) return null;
  const max = Math.max(...data.sites.map((s) => Math.abs(s.net_margin_gbp)), 1);

  return (
    <div className="mb-6" data-testid="margin-leaderboard">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <div className="label flex items-center gap-2"><Trophy size={13} className="text-[var(--accent)]" /> Net operating margin leaderboard</div>
        <div className="flex items-center gap-3">
          {data.loss_count > 0 && (
            <span className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-[#FBEAE7] text-[#C0392B] inline-flex items-center gap-1" data-testid="leaderboard-loss">
              <AlertTriangle size={12} /> {data.loss_count} running at a loss
            </span>
          )}
          <select value={months} onChange={(e) => setMonths(Number(e.target.value))} className="input-swiss py-1 text-xs w-auto" data-testid="leaderboard-months">
            <option value={3}>Last 3 mo</option>
            <option value={6}>Last 6 mo</option>
            <option value={12}>Last 12 mo</option>
          </select>
        </div>
      </div>
      <div className="swiss-card-flat divide-y divide-[var(--line)]">
        {data.sites.map((s) => {
          const pos = s.net_margin_gbp >= 0;
          const c = pos ? "#15934F" : "#C0392B";
          const w = (Math.abs(s.net_margin_gbp) / max) * 100;
          return (
            <div key={s.project_id} className="flex items-center gap-3 px-4 py-2.5" data-testid={`leaderboard-row-${s.project_id}`}>
              <span className="w-6 text-center text-xs font-bold muted">{s.rank}</span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-[13px] font-medium truncate">{s.project_name}{!pos && <TrendingDown size={12} className="inline ml-1.5 text-[#C0392B]" />}</span>
                  <span className="font-mono text-sm font-bold" style={{ color: c }}>{fmtGbp(s.net_margin_gbp)}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex-1 h-1.5 rounded-full bg-[var(--line-soft,#EEF2F4)] overflow-hidden">
                    <span className="block h-full rounded-full" style={{ width: `${w}%`, background: c }} />
                  </div>
                  <span className="text-[10px] muted font-mono whitespace-nowrap">in {fmtGbp(s.income_gbp)} · out {fmtGbp(s.spend_gbp)}{s.margin_pct != null ? ` · ${s.margin_pct}%` : ""}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
